import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowUpRightFromSquare,
  faBan,
  faBookOpenCover,
  faBooks,
  faBullseyeArrow,
  faCaretDown,
  faCaretRight,
  faChartLineDown,
  faChartLineUp,
  faCheck,
  faChevronDown,
  faChevronRight,
  faCircle,
  faCircleCheck,
  faCircleInfo,
  faCircleNodes,
  faCircleXmark,
  faClock,
  faClockRotateLeft,
  faCross,
  faDash,
  faDiagramProject,
  faDown,
  faDownload,
  faEye,
  faEyeSlash,
  faFileCertificate,
  faFileCheck,
  faFileExport,
  faGauge,
  faHand,
  faHiking,
  faHyphen,
  faLayerGroup,
  faLayerPlus,
  faLink,
  faList,
  faLock,
  faLockA,
  faMedal,
  faMoneyCheckDollarPen,
  faMountain,
  faPersonRunning,
  faQuestionCircle,
  faRotate,
  faScreenUsers,
  faSitemap,
  faSpinner,
  faSwap,
  faThumbsDown,
  faThumbsUp,
  faTicket,
  faTriangleExclamation,
  faUp,
  faUserCheck,
  faUserHardHat,
  faUserHeadset,
  faUserSecret,
  faUsers,
  faVrCardboard,
  faWifi,
  faXmark,
} from "@fortawesome/pro-solid-svg-icons";

export function initSolidIcons() {
  library.add(
    faArrowUpRightFromSquare,
    faBan,
    faBookOpenCover,
    faBooks,
    faBullseyeArrow,
    faCaretDown,
    faCaretRight,
    faChartLineDown,
    faChartLineUp,
    faCheck,
    faChevronDown,
    faChevronRight,
    faCircle,
    faCircleCheck,
    faCircleInfo,
    faCircleNodes,
    faCircleXmark,
    faClock,
    faClockRotateLeft,
    faCross,
    faDash,
    faDiagramProject,
    faDown,
    faDownload,
    faEye,
    faEyeSlash,
    faFileCertificate,
    faFileCheck,
    faFileExport,
    faGauge,
    faHand,
    faHiking,
    faHyphen,
    faLayerGroup,
    faLayerPlus,
    faLink,
    faList,
    faLock,
    faLockA,
    faMedal,
    faMoneyCheckDollarPen,
    faMountain,
    faPersonRunning,
    faQuestionCircle,
    faRotate,
    faScreenUsers,
    faSitemap,
    faSpinner,
    faSwap,
    faThumbsDown,
    faThumbsUp,
    faTicket,
    faTriangleExclamation,
    faUp,
    faUserCheck,
    faUserHardHat,
    faUserHeadset,
    faUserSecret,
    faUsers,
    faVrCardboard,
    faWifi,
    faXmark
  );
}
